//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowDropdown(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 3.68994L7 7.88995V10.4999L12 6.30994L17 10.4999V7.88995L12 3.68994ZM7 13.4999V16.1099L12 20.3099L17 16.1099V13.4999L12 17.6899L7 13.4999Z" fill="currentColor" /></svg>;
}
export default IconArrowDropdown;